import { fetchBlogs } from "@/services/supabaseService";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import BlogCard from "./BlogCard";

const Blogs = () => {
  const navigate = useNavigate();
  const navigateToPage = (path: string) => {
    navigate(path);
  };
  const { data: blogs = [] } = useQuery({
    queryKey: ["blogs"],
    queryFn: fetchBlogs,
  });
  return (
    <div id="blogs" className="container max-w-6xl mx-auto py-20 px-6">
      <div className="animate-slide-down">
        <h2 className="text-4xl font-bold mb-2 text-teal">Blog Posts</h2>
        <p className="text-gray-400 mb-6 max-w-2xl">
          Some of my thoughts and tutorials on web development.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {blogs.slice(0, 3).map((post, index) => (
          <BlogCard key={post.id} post={post} index={index} />
        ))}
      </div>

      <div className="flex justify-center">
        <Button
          onClick={() => navigateToPage("/blogs")}
          className="bg-teal hover:bg-teal-dark text-navy-dark flex items-center gap-2"
        >
          View More
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default Blogs;
